<template>
  <kst-section :title="Info.Section.TransactionSetting.Title">
    <kst-output field="DiscPercent" :data="data" :catalog="Catalog"/>
  </kst-section>
</template>

<script>
import Catalog from "../CliCatalog.js";
import Info from "../CliInfo.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog,
    Info: Info,
  })
}
</script>